<template>
    <v-container fluid fill-height>
        <Headful title="Wachtwoord resetten"></Headful>
        <Header
            color="white"
            show-logo
            :dark="false"
            extended
        ></Header>
        <v-layout align-center justify-center>
            <v-flex>
                <p v-if="validatingToken" class="text-center my-7"><v-icon large color="primary">fal fa-spinner-third fa-spin</v-icon></p>
                <v-alert v-else-if="!isTokenValid" dark color="error" class="text-center my-7">Deze reset link is niet (meer) geldig.</v-alert>
                <div v-else>
                    <v-form ref="form" @submit.prevent="resetPassword" class="px-5">
                        <v-card class="elevation-0">
                            <v-card-text class="pa-7">
                                <h1 class="text-h5 mb-5 text-center text--success">Wachtwoord resetten</h1>
                                <p class="text-center mb-5">Voer hieronder een nieuw wachtwoord in voor uw account.</p>
                                <v-text-field
                                    type="password"
                                    outlined
                                    rounded
                                    hide-details="auto"
                                    single-line
                                    v-model="firstPassword"
                                    label="Nieuw wachtwoord"
                                    :rules="firstPasswordRules"
                                    required
                                    class="mb-2"
                                ></v-text-field>
                                <v-text-field
                                    type="password"
                                    outlined
                                    rounded
                                    hide-details="auto"
                                    single-line
                                    v-model="secondPassword"
                                    label="Herhaal wachtwoord"
                                    :rules="secondPasswordRules"
                                    required
                                    class="mb-5"
                                ></v-text-field>
                                <v-btn type="submit" color="primary" rounded :loading="submitting" :disabled="submitting || firstPassword.length < 6 || secondPassword.length < 6 || firstPassword != secondPassword" block class="mb-2 elevation-0">Wachtwoord resetten</v-btn>
                                <v-btn :to="{name: 'SignIn'}" block outlined rounded color="secondary" class="elevation-0">Terug naar inloggen</v-btn>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </div>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
import Headful from "@/components/layout/Headful";
import Header from "@/components/layout/Header";

export default {
    name: "ForgotPassword",
    components: {
        Headful,
        Header
    },
    data: () => ({
        firstPassword: '',
        firstPasswordRules: [
            v => !!v || 'Wachtwoord is verplicht',
            v => (!v || v.length >= 6) || 'Minimaal 6 karakters',
        ],
        secondPassword: '',
        submitting: false,
        validatingToken: true,
        isTokenValid: false,
    }),
    computed: {
        secondPasswordRules () {
            return [
                v => !!v || 'Wachtwoord is verplicht',
                v => v === this.firstPassword || 'Wachtwoorden komen niet overeen',
                v => (!v || v.length >= 6) || 'Minimaal 6 karakters',
            ];
        },
    },
    mounted () {
        this.$store.dispatch('validateResetPasswordToken', {
            token: this.$route.params.token,
        }).then(isValid => {
            this.isTokenValid = isValid;
        }).catch((e) => {
            console.error(e);
            this.isTokenValid = false;
        }).finally(() => {
            this.validatingToken = false;
        });
    },
    methods: {
        resetPassword () {
            // Check if form is valid
            if (!this.$refs.form.validate() || this.submitting) {
                return;
            }

            this.submitting = true;

            // Submit data to auth store
            this.$store.dispatch('resetPassword', {
                token: this.$route.params.token,
                password: this.firstPassword,
            }).then(() => {
                this.$store.dispatch('showSnackbar', { color: 'success', text: 'Wachtwoord opnieuw ingesteld'});
                return this.$router.push({ name: 'SignIn' });
            }).catch((e) => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Serverfout, neem contact op' });
            }).finally(() => {
                this.submitting = false;
            });
        },
    },
}
</script>

<style scoped>

</style>
